import { Button, message, Table } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../../server";
import Calendar from "./calendar";
import { Popconfirm } from "antd";
import { LogMonitor } from "@/controls";

const CalendarsList = ({ selected, setSelected, onRefresh }) => {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [edit, setEdit] = useState();

  const getData = () => {
    setLoading(true);
    serverFetch("calendar")
      .then(data => {
        setItems(data);
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(getData, []);

  const onFullRefresh = () => {
    getData();
    onRefresh();
  }

  const columns = [
    { dataIndex: "id", title: "#", },
    { dataIndex: "name", title: "Календарь", },
  ]

  const onDelete = () => {
    setLoading(true);
    serverFetch(`calendar/${selected}`, { method: "DELETE" })
      .then(() => {
        setSelected(null);
        setLoading(false);
        getData();
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  const onClose = id => {
    setEdit(false);
    setSelected(id);
    id && onFullRefresh();
  }

  const onCopy = () => {
    if (window.confirm("Копировать?")) {
      setLoading(true);
      serverFetch(`calendar/${selected}`)
        .then(data => {
          serverFetch("calendar", {method: "POST", bodyData: {...data, name: "Копия " + data.name}})
            .then((data2) => {
              setSelected(data2.id);
              // onFullRefresh();
            })
            .catch(e => {
              setLoading(false);
              message.error(e.userMessage);
            })
        })
        .catch(e => {
          setLoading(false);
          message.error(e.userMessage);
        })
    }
  }

  return<div className="col2-col">
    <div className="sport-form-title">
      <Button onClick={() => { setSelected(null); setEdit(true); }}>Добавить</Button>
      <Popconfirm title="Подтверждение" description="Удалить?" onConfirm={onDelete}>
        <Button disabled={!selected}>Удалить</Button>
      </Popconfirm>
      <Button onClick={() => setEdit(true)} disabled={!selected}>Изменить</Button>
      <Button disabled={!selected} onClick={onCopy}>Копия</Button>
      <LogMonitor vid={7} id={selected}/>
    </div>
    <Table 
      size="small"
      dataSource={items}
      columns={columns}
      rowKey="id"
      loading={loading}
      className="table-main"
      pagination={false}
      rowSelection={{ type: 'radio', selectedRowKeys: [selected], renderCell: checked => <div className={checked ? "list-indicator" : ""} /> }}
      onRow={(record) => ({onClick: () => {setSelected(record.id)}})}
    />
    {edit && <Calendar id={selected} onClose={onClose}/>}
  </div>
}

export default CalendarsList;